import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearLocalStore } from "helpers/localStoreSrv";
import { useSurveySrv } from "../Survey/useSurveySrv";
import { getLanguageId, LANGUAGES } from "./../../constants/supported_lang";
import { Card, Typography, Row, Col, Grid, theme, Spin, Button } from "antd";
import {
  // ArrowRightOutlined,
  // HomeOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { useValidateVisibilityHook } from "./useValidateVisbiltyHook";
import BrandColors from "@brand-colors";
import { useTranslation } from "react-i18next";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import whitelabelConfig from "@whitelabel-config";
import PendingSurveyList from "./../../components/PendingSurveyList/PendingSurveyList";
import { useAuthProvider } from "pages/Auth/hooks/useAuthProvider";
import { portalActions } from "store/portal-slice";
import useToasterMessage from "helpers/useToasterMessage";
import DOMPurify from "dompurify";
import { usePageTitle } from "helpers/usePageTitle";
const { Title } = Typography;

const RuleBasedThankYou = () => {
  //const { thankyouState } = useSelector((state: any) => state.portal.uiState);
  const authState = useSelector((state: any) => state.portal.authSession);
  const formData = useSelector((state: any) => state.portal.formData);

  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const { useToken } = theme;
  const { token } = useToken();
  const screens = useBreakpoint();
  //const [cnfmText, setCnfmText] = useState("");
  const [renderHtml, setRenderHtml] = useState("");
  const [renderHtmlOrderTwo, setRenderHtmlOrderTwo] = useState("");
  //const [thankYouText, setThankYouText] = useState("");
  //const [handleConfText, setHandleConfText] = useState(true);
  const [confirmData, setConfirmData] = useState();
  const [isConfirmTq, setIsConfirmTq] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  usePageTitle("THANKYOU.PAGE_TITLE", `Thank You - ${process.env.REACT_APP_PRODUCT}`);
  //const location = useLocation();
  const appUiState = useSelector((state: any) => state.portal.uiState);
  //const { preferredLanguage } = location.state || appUiState?.Language || "en";

  const [currentLanguage, setCurrentLanguage] = useState(appUiState?.Language);
  const validateVisibilityRule = useValidateVisibilityHook(confirmData);
  const { getSurevyData, getLanguageTranslations, familySurveyPendingSurveys } =
    useSurveySrv();
  //const [confirmationText, setConfirmationText] = useState("");
  const portalMicrositeSession = useSelector(
    (state: any) => state.portal.micrositeSession
  );
  const { initAuth } = useAuthProvider();
  const handlePendingSurvey = () => {
    initAuth("PII");
  };
  const dispatch = useDispatch();
  const [pendingList, setpendingList] = useState(true);
  useEffect(() => {
    console.log("appUiState?.Language", appUiState?.Language);
    setCurrentLanguage(appUiState?.Language);
  }, [appUiState]);

  const updateConfirmationsByLang = (
    surveyConfirmations: any[],
    languageCode: string,
    langData: any[]
  ) => {
    // Filter language data for the current language
    const updatedLangData =
      langData.filter((item: any) => item.LanguageCode === languageCode) || [];

    return surveyConfirmations.map((confirmation: any) => {
      // Find a matching text value for confirmationText
      const confirmationTextMatch = updatedLangData.find(
        (item: any) => item.TextCode === confirmation.confirmationText
      );
      if (confirmationTextMatch) {
        confirmation.confirmationText = confirmationTextMatch.TextValue;
      }
      console.log("confirmationTextMatch", confirmationTextMatch);
      // Find a matching text value for renderHtml
      const renderHtmlMatch = updatedLangData.find(
        (item: any) => item.TextCode === confirmation.renderHtml
      );
      if (renderHtmlMatch) {
        confirmation.renderHtml = renderHtmlMatch.TextValue;
      }
      console.log("renderHtmlMatch", renderHtmlMatch);
      //console.log("confirmation", confirmation);
      return confirmation;
    });
  };

  const getIdByCode = (code: string) => {
    const language = LANGUAGES.find((lang) => lang.code === code);
    return language?.id || null; // Return the id if found, otherwise return null
  };
  useEffect(() => {
    if (!authState.is_authenticated) {
      clearLocalStore();
      navigate("/error", {
        state: {
          errorCode: "401",
          errorTitle: t("LANDING.UNAUTHORIZED_DEFAULT"),
          errorDescription: "",
        },
      });
    } else {
      // Force reload to this route if accessed from history
      window.history.pushState(null, "", window.location.href);
    }
  }, []);

  useEffect(() => {
    const fetchSurveyData = async () => {
      try {
        setIsLoading(true);
        const surveyResponse = await getSurevyData();
        const surveyData = surveyResponse?.data;
        if (surveyData?.IsRuleBasedSurvey) {
          const surveyJson = await fetch(surveyData.SurveyUrl).then((res) =>
            res.json()
          );
          const languageData = await getLanguageTranslations(
            surveyData?.TranslationGroupID,
            getLanguageId(currentLanguage)
          );
          const languageRes = languageData?.data;
          const languageCode = getIdByCode(currentLanguage);
          console.log("languageCode___", languageCode);
          const updatedConfirmations = updateConfirmationsByLang(
            surveyJson.surveyConfirmations,
            languageCode,
            languageRes
          );
          const isConfirm = runVisibilityRule(updatedConfirmations);
          const index = isConfirm ? 0 : 1;
          setRenderHtml(updatedConfirmations[index]?.renderHtml || "");
          setIsConfirmTq(isConfirm);
        }
        setIsLoading(false);
      } catch (error) {
        handleErrorNavigation(error, navigate, t);
        console.error(
          "Error fetching survey data or TranslationGroupID",
          error
        );
      }
    };

    if (!authState.is_authenticated) {
      const navParams = {
        state: {
          errorCode: "401",
          errorTitle: t("LANDING.UNAUTHORIZED_DEFAULT"),
          errorDescription: "",
        },
      };
      clearLocalStore();
      navigate("/error", navParams);
    } else {
      fetchSurveyData();
    }

    familySurveyPendingSurveys()
      ?.then((res) => {
        console.log("familySurveyPendingSurveys", res.data);
        if (
          whitelabelConfig.uiSettings.isFamilySurveyEnabled &&
          res.data.PendingSurveys &&
          res.data.PendingSurveys.length > 0
        ) {
          const sessionPayload = {
            pendingSurveys: res.data.PendingSurveys,
          };
          dispatch(portalActions.updateMicrositeSession(sessionPayload));
          let isFamilySurveyOpen = res.data.PendingSurveys.filter((m) => {
            return m.ActivityStatus == 120000000;
          });
          console.log("isFamilySurveyOpen ", isFamilySurveyOpen);
          if (isFamilySurveyOpen && isFamilySurveyOpen.length == 0) {
            setpendingList(false);
          }
        }
      })
      .catch((e) => {
        handleErrorNavigation(e, navigate, t);
      });
  }, [authState, navigate, t, currentLanguage]);
  useEffect(() => {
    const preventBack = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", preventBack);

    return () => {
      window.removeEventListener("popstate", preventBack);
    };
  }, []);



  const runVisibilityRule = (surveyConfirmations: any) => {
    let visible = false;
    surveyConfirmations.forEach((obj: any) => {
      if (obj.isVisibleConditionEnabled) {
        obj.visibleCondition?.filterConditions?.forEach((element: any) => {
          const result = validateVisibilityRule(element, formData);
          visible = visible || result;
        });
      }
    });
    return visible;
  };

  const styles = {
    section1: {
      alignItems: "center",
      backgroundColor: BrandColors.HEADER_BG,
      display: "flex",
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      color: token.colorBgContainer,
      padding: screens.md ? `15px` : "10px",
      borderRadius: "5px",
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading3 : token.fontSizeHeading4,
      marginTop: "0",
      marginBottom: "20px",
    },
    title1: {
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      marginTop: "0",
      marginBottom: "20px",
    },
    button: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
      // fontFamily: "Montserrat,sans-serif",
    },
  };
  console.log("isConfirmTq", isConfirmTq);
  if (isLoading) return <Spin size="large" />;
  return (
    <div>
      <Row className="page-wrapper justify-content-md-center thankyoupage">
        <Col md={24} sm={24}>
          <Card className="hls-container">
            <div className="card-body thank-container">
              <div
                style={styles.title}
                role="region"
                aria-label={t("THANKYOU.TITLE", { defaultValue: "Thank-you content" })}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(renderHtml) }}
                id="rb-thankyou-title"
                tabIndex={0}
              />
            </div>
          </Card>
        </Col>
        {
          whitelabelConfig.uiSettings.isFamilySurveyEnabled &&
          portalMicrositeSession?.pendingSurveys &&
          pendingList && (
            // <Row className="page-wrapper justify-content-md-center thankyoupage">
            <Col md={24} sm={24} xs={24}>
              <Card
                className="hls-container"
                title={t("THANKYOU.FAMILY_SURVEY_TITLE")}
                headStyle={{
                  fontWeight: "normal",
                  textAlign: "left",
                  paddingLeft: "40px",
                  paddingRight: "40px",
                }}
                extra={
                  <Button
                    type="primary"
                    shape="circle"
                    icon={<RightOutlined />}
                    onClick={handlePendingSurvey}
                    style={styles.button}
                    id="rulebased-thankyou-family-survey-btn"
                  />
                }
              >
                <div className="card-body thank-container">
                  <PendingSurveyList
                    surveyList={portalMicrositeSession.pendingSurveys}
                    onSelectSurvey={(surveyMeta: any) => {
                      console.log(surveyMeta);
                    }}
                  />
                </div>
              </Card>
            </Col>
          )
          // </Row>
        }
      </Row>
      {/* )} */}
    </div>
  );
};

export default RuleBasedThankYou;
